'use strict';

import './includes/initDocumentScripts';

import './modules';

import './includes/initFeatherlight';

import './includes/initSlick';

import './includes/initSmoothScroll';

import './includes/initMemoPlaceholder';

import './includes/initAccordions';

import './includes/initInview';

import './includes/initAboutField';

import './includes/initMainNav';

import './includes/initVimeo';
